import React from 'react';
import { Segment, Button, Icon, Menu } from 'semantic-ui-react';
import MenuItems from './MenuItems';
import Toggleable from '../../../darkmatter/Toggleable';
import { AsPropType, LinkPropType, TextAlignPropType } from '../../../services/proptypes';
var defaultProps = {
  position: 'left',
  className: '',
  invertedHamburgerButton: false
};
export default function MobileMenu(_ref) {
  var logo = _ref.logo,
    position = _ref.position,
    links = _ref.links,
    linksAs = _ref.linksAs,
    className = _ref.className,
    backgroundColor = _ref.backgroundColor,
    invertedHamburgerButton = _ref.invertedHamburgerButton;
  return /*#__PURE__*/React.createElement(Segment, {
    className: className,
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(Toggleable, null, function (toggle, onToggle) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "mobile-nav-header"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onToggle,
      style: {
        "float": position === 'left' ? 'right' : 'left'
      },
      "aria-label": "Open navigation bar"
    }, /*#__PURE__*/React.createElement(Icon, {
      inverted: invertedHamburgerButton,
      name: "bars",
      size: "large",
      style: {
        margin: '0 auto',
        height: 'unset'
      }
    })), /*#__PURE__*/React.createElement("div", null, logo)), toggle && /*#__PURE__*/React.createElement(Menu, {
      vertical: true,
      className: "mobile-nav-menu"
    }, /*#__PURE__*/React.createElement(MenuItems, {
      links: links,
      linksAs: linksAs
    })));
  }));
}
MobileMenu.defaultProps = defaultProps;